import { stringify } from "query-string";
import { httpClient } from "./httpClient";
import { SortPayload } from "ra-core";

const DownloadCSV = async (
  filenamePrefix: string,
  custID: number,
  resource: string,
  sort: SortPayload,
  filterValues: Record<string, unknown>,
  addlParams?: Record<string, unknown>,
) => {
  const queryParams = stringify({
    sort: JSON.stringify([sort.field, sort.order]),
    filter: JSON.stringify(filterValues),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...addlParams,
  });

  const url = "/api/v2/c/" + custID + "/" + resource + "/csv?" + queryParams;

  const d = new Date();
  const dateStr = d.toLocaleDateString("en-CA"); // YYYY-MM-DD
  const timeStr = d
    .toLocaleTimeString("en-GB", { hour12: false })
    .replace(/:/g, ""); // HHMMSS
  const tz = d
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")
    .pop(); // MST/UTC/etc
  const filename = `${filenamePrefix}_${dateStr}_${timeStr}_${tz}.csv`;

  const resp = await httpClient(url);
  if (resp.ok) {
    const blob = await resp.blob();
    const file = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = file;
    a.download = filename;
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove(); //afterwards we remove the element again
  } else {
    throw new Error((await resp.json()).message);
  }
};

export { DownloadCSV };
